import { useCallback, useRef } from "react"

const useFlushingBuffer = <T>({
  handleTextChunk,
}: {
  handleTextChunk: (buffer: T) => void
}) => {
  const bufferRef = useRef<T | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const clearFlushTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const flush = useCallback(() => {
    clearFlushTimeout()
    if (!bufferRef.current) return
    handleTextChunk(bufferRef.current)
    bufferRef.current = null
  }, [clearFlushTimeout, handleTextChunk])

  const scheduleFlush = useCallback(() => {
    clearFlushTimeout()
    timeoutRef.current = setTimeout(flush, 2000)
  }, [clearFlushTimeout, flush])

  return { bufferRef, flush, scheduleFlush }
}

export default useFlushingBuffer
